export default __webpack_public_path__ + "static/media/warning.44038cab.wav";